import { NodeType } from '@/enums/node-type.enum';
import { appendFigmaNodeConnectionPersistence } from '../Nodes/FigmaNode/figmaNodeConnectionPersistence';
import type { Node } from '@/types/node';
import type { UndoRedoEntry } from './undoRedo';

type NodeRemoveHandler = (node: Node, undoEntry: UndoRedoEntry) => void;

/** Node-type-specific handlers when nodes leave the graph. Add an entry to support another type. */
const NODE_REMOVE_HANDLERS: Partial<Record<NodeType, NodeRemoveHandler>> = {
  [NodeType.FigmaNode]: appendFigmaNodeConnectionPersistence,
};

/**
 * Run registered per-type handlers for nodes being removed (e.g. drop a Figma connection row and
 * attach its undo recreate). Pass nodes read before `store.removeNodes`.
 */
export function applyNodeRemoveHandlers(nodes: Node[], undoEntry: UndoRedoEntry): void {
  for (const node of nodes) {
    NODE_REMOVE_HANDLERS[node.type as NodeType]?.(node, undoEntry);
  }
}
